import React, { useState, useRef, useEffect } from 'react';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import Typography from '@mui/material/Typography';
import { Box } from "@mui/material";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useTranslation } from 'react-i18next';
import useForceUpdateTranslation from '@utils/useForceUpdateTranslation';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { purgeOrganiztion } from '@modules/organization';
import { purgeChapter } from '@modules/chapter';
import { purgeEditor } from '@modules/editor';
import { purgeMedia } from '@modules/media';
import { purgeSubtitle } from '@modules/subtitle';

function HeaderMenu({ openMenu, setOpenMenu, anchorElUser, toggleModal }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [isSubMenu, setIsSubMenu] = useState(false);
    const menuRef = useRef(null);
    const { t } = useForceUpdateTranslation();
    const lang = useSelector(state => state.ui.lang);

    const handleCloseUserMenu = (menu: string) => {
        if (menu === 'logout') {
            handleLogout();
        }
        else if (menu === 'settings') {
            navigate('/settings');
        }
    };

    function handleLogout() {
        console.log('logout')

        dispatch(purgeOrganiztion());
        dispatch(purgeMedia());
        dispatch(purgeOrganiztion());
        dispatch(purgeEditor());
        dispatch(purgeSubtitle());
        dispatch(purgeChapter());

        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('userToken')
    }

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                handleCloseUserMenu('');
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <Box>
            <Menu
                id="menu-appbar"
                anchorEl={anchorElUser}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                open={openMenu}
                onClose={() => setOpenMenu(false)}
                ref={menuRef}
                disablePortal
            >
                <Box
                    className="header-menu-slider"
                    style={{
                        transform: isSubMenu ? "translateX(-200px)" : "translateX(0)"
                    }}
                >
                    <Box className="header-menu-main">
                        <MenuItem onClick={() => navigate('/settings')}><Typography>{t('header.settings')}</Typography></MenuItem>
                        <MenuItem className="header-menu-main-lang" onClick={() => setIsSubMenu(true)}>
                            <div><Typography>{t('settings.general.language')}</Typography></div>
                            <div className="header-menu-main-lang-arrow"><ArrowForwardIosIcon /></div>
                        </MenuItem>
                        <MenuItem onClick={() => handleLogout()}>{t('header.logout')}</MenuItem>
                    </Box>

                    <Box className="header-menu-lang">
                        <MenuItem className="header-menu-lang-back" onClick={() => setIsSubMenu(false)}>
                            <div className="header-menu-lang-back-arrow"><ArrowBackIcon /></div>
                            <div>{t('settings.general.language')}</div>
                        </MenuItem>
                        <MenuItem className="header-menu-lang-select" onClick={toggleModal}>
                            <div className="header-menu-lang-endonym">{lang?.endonym}</div>
                            <div className="header-menu-lang-localized">{lang?.localizedName}</div>
                        </MenuItem>
                    </Box>

                </Box>
            </Menu>
        </Box>
    );
}

export default HeaderMenu;